<template>
    <div class="input__inner">
        <input
            :type="type"
            class="input"
            :class="{'input_error': error}"
            :placeholder="placeholder"
            :value="value"
            :name="name"
            @input="$emit('input', $event.target.value)"
            @focus="$emit('update:error', false)"
            @blur="checkValidData"
            :disabled="disabled"
        >

        <div class="input__inner-error" :class="{'input__inner-error_active': error}">
            <span>{{ errorText }}</span>
        </div>
    </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
        type: String,
        default: "",
    },
    placeholder: {
        type: String,
        default: "",
    },
    type: {
        type: String,
        default: "",
    },
    name: {
        type: String,
        default: "",
    },
    error: {
        type: Boolean,
        default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validateOptions: {
        type: Array,
        default: function() {
            return []
        }
    },
    validateString: {
      type: String,
      default: "",
    }
  },
  data() {
      return {
          errorText: ''
      }
  },
  methods: {
        checkValidData(e) {
            const value = e.target.value
    
            // email rules
            if (this.validateOptions.includes('email')) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (!re.test(String(value).toLowerCase())) {
                    this.errorText = 'Некоректная почта'
                    this.$emit('update:error', true)
                }
            }

            // empty rules
            if (this.validateOptions.includes('empty')) {
                if (!value.length) {
                    this.errorText = 'Заполните поле'
                    this.$emit('update:error', true)
                }
            }

            if (this.validateOptions.includes('password')) {
              if (value !== this.validateString && this.validateString !== "") {
                this.errorText = 'Пароли должны совпадать'
                this.$emit('update:error', true)
              }
            }
        },
  }
}
</script>